module.exports = __webpack_public_path__ + "static/media/menuQueue.01f426b9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/menuQueue.svg
// module id = 480
// module chunks = 0